import { makeApiCall } from "../makeApiCall";
import { AdminService_URL } from "../Url";

export const MissingMedDashActions = {
  MISSING_MED_DASHBOARD_SUCCESS: "MISSING_MED_DASHBOARD_SUCCESS",
  MISSING_MED_DASHBOARD_FAILURE: "MISSING_MED_DASHBOARD_FAILURE",
  FETCH_MISSING_MED_SUCCESS: "FETCH_MISSING_MED_SUCCESS",
  FETCH_MISSING_MED_FAILURE: "FETCH_MISSING_MED_FAILURE",
};

////? Missing Med dashboard Service

export function missingMedDashboardSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: MissingMedDashActions.MISSING_MED_DASHBOARD_SUCCESS,
      payload: props,
    });
  };
}

export function missingMedDashboardFailureAction(error) {
  return {
    type: MissingMedDashActions.MISSING_MED_DASHBOARD_FAILURE,
    payload: error,
  };
}

export function MissingMedDashboardThunk(props, warehouseIds) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/fetchMissingMedicineDashboard?fromDate=${
    props.fromDate
  }&toDate=${props.toDate}${
    props.isMissing === true
      ? "&isMissing=true"
      : props.isExpired === true
      ? "&isExpired=true"
      : props.isDamaged === true
      ? "&isDamaged=true"
      : ""
  }`;
  // const postUrl = `https://2f3644cc-0bd6-4783-bb70-9c3f3cd1136d.mock.pstmn.io/fetchMissingMedicineDashboard?fromDate=${
  //   props.fromDate
  // }&toDate=${props.toDate}${
  //   props.isMissing === true
  //     ? "&isMissing=true"
  //     : props.isExpired === true
  //     ? "&isExpired=true"
  //     : props.isDamaged === true
  //     ? "&isDamaged=true"
  //     : ""
  // }`;
  return makeApiCall(
    postUrl,
    missingMedDashboardSuccessAction,
    missingMedDashboardFailureAction,
    "POST",
    warehouseIds,
    reqHeader,
    props.history
  );
}

////? Fetch Missing Med Service

export function fetchMissingMedSuccessAction(props) {
  return (dispatch) => {
    dispatch({
      type: MissingMedDashActions.FETCH_MISSING_MED_SUCCESS,
      payload: props,
    });
  };
}

export function fetchMissingMedFailureAction(error) {
  return {
    type: MissingMedDashActions.FETCH_MISSING_MED_FAILURE,
    payload: error,
  };
}

export function fetchMissingMedThunk(props) {
  const reqHeader = {
    transactionId: "a",
    "Content-Type": "application/json",
    Authorization: "Bearer " + props.access_token,
  };
  const postUrl = `${AdminService_URL}/fetchMissingMedicineDetailsWithReasons?warehouseId=${props.warehouseId}&orderId=${props.orderId}
  `;
  return makeApiCall(
    postUrl,
    fetchMissingMedSuccessAction,
    fetchMissingMedFailureAction,
    "GET",
    null,
    reqHeader,
    props.history
  );
}
